import { systemEngineEnvironment } from "services/environment/systemEngine";

export const resetLoginPassword = async (loginName: string) => {
  await systemEngineEnvironment.execute(
    `CALL fb_ResetLoginPassword('${loginName}')`
  );
};
